import {
    ItinerarySectionType,
    ItineraryStatus,
    StreetAttributes,
    TimelineEventType,
    TruckAttributes,
    type ItinerariesResponse,
} from '../../../src/store/facade/facadeApiV3';
import { getCoordinatesFromItinerary } from '../../../src/store/tour/tourSlice';
import { tourIdList } from './tourMock';

export const itineraryMock4: ItinerariesResponse = {
    itineraries: [
        {
            tourId: tourIdList[0],
            itineraryId: '517d3123-4a8f-4aa4-b07e-4b5b39b7ghi',
            status: ItineraryStatus.Current,
            summary: {
                distance: 315269,
                duration: 13500,
                evConsumption: 123,
                evChargingDuration: 456,
                driverCost: 0.8,
                vehicleCost: 10.01,
                energyCost: 30.01,
                minTotalCost: 45.03,
                maxTotalCost: 55.3,
                minTollCost: 5.01,
                maxTollCost: 10.01,
            },
            sections: [
                {
                    sectionId: 0,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T08:00:00.000Z',
                    arrivalTime: '2023-09-11T08:30:00.000Z',
                    distance: 315269,
                    duration: 14584,
                    evConsumption: 123,
                    evBatteryCapacityDeparture: 95,
                    evBatteryCapacityArrival: 21,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 130,
                            distance: 315269,
                            duration: 14584,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 38.726334, longitude: -9.14952 },
                                { latitude: 39.5467, longitude: -8.9865 },
                            ],
                        },
                    ],
                },
                {
                    sectionId: 1,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T08:30:00.000Z',
                    arrivalTime: '2023-09-11T13:00:00.000Z',
                    distance: 200000,
                    duration: 16200,
                    evConsumption: 80,
                    evBatteryCapacityDeparture: 21,
                    evBatteryCapacityArrival: 21,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 80,
                            distance: 200000,
                            duration: 16200,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 39.5467, longitude: -8.9865 },
                                { latitude: 40.3435, longitude: -8.5968 },
                            ],
                        },
                    ],
                },
                {
                    sectionId: 2,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T13:00:00.000Z',
                    arrivalTime: '2023-09-11T18:10:00.000Z',
                    distance: 14584,
                    duration: 18653,
                    evConsumption: 50,
                    evBatteryCapacityDeparture: 21,
                    evBatteryCapacityArrival: 0,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 50,
                            distance: 14584,
                            duration: 18653,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 40.3435, longitude: -8.5968 },
                                { latitude: 41.14584, longitude: -8.610815 },
                            ],
                        },
                    ],
                },
            ],
            events: {
                timelineEvents: [
                    {
                        eventId: 1,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Departure,
                        coordinates: { latitude: 38.726334, longitude: -9.14952 },
                        address: {
                            name: 'Lisboa',
                            street: 'Praça do Comércio',
                            city: 'Lisboa',
                            countryCode: 'PRT',
                            postalCode: '1100-148',
                        },
                        expectedBatteryLevelAtDeparture: 95,
                    },
                    {
                        eventId: 2,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 0,
                    },
                    {
                        eventId: 3,
                        waypointId: 1,
                        occurredAt: '2023-09-11T08:30:00.000Z',
                        timelineEventType: TimelineEventType.IntermediateStop,
                        coordinates: { latitude: 39.5467, longitude: -8.9865 },
                        address: {
                            name: 'Santarém',
                            street: 'Rua Central',
                            city: 'Santarém',
                            countryCode: 'PRT',
                            postalCode: '2000-001',
                        },
                        expectedBatteryLevelAtArrival: 21,
                        duration: 14584,
                    },
                    {
                        eventId: 4,
                        occurredAt: '2023-09-11T08:30:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 1,
                    },
                    {
                        eventId: 5,
                        waypointId: 2,
                        occurredAt: '2023-09-11T13:00:00.000Z',
                        timelineEventType: TimelineEventType.IntermediateStop,
                        coordinates: { latitude: 40.3435, longitude: -8.5968 },
                        address: {
                            name: 'Coimbra',
                            street: 'Av. da Liberdade',
                            city: 'Coimbra',
                            countryCode: 'PRT',
                            postalCode: '3000-001',
                        },
                        expectedBatteryLevelAtArrival: 21,
                        duration: 14584,
                    },
                    {
                        eventId: 6,
                        occurredAt: '2023-09-11T13:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 2,
                    },
                    {
                        eventId: 7,
                        occurredAt: '2023-09-11T18:10:00.000Z',
                        timelineEventType: TimelineEventType.Arrival,
                        coordinates: { latitude: 41.14584, longitude: -8.610815 },
                        address: {
                            name: 'Porto',
                            street: 'Rua de Santa Catarina',
                            city: 'Porto',
                            countryCode: 'PRT',
                            postalCode: '4000-447',
                        },
                        expectedBatteryLevelAtArrival: 0,
                    },
                ],
            },
        },
        {
            tourId: tourIdList[0],
            itineraryId: '517d3123-4a8f-4aa4-b07e-4b5b39b7def',
            status: ItineraryStatus.Current,
            summary: {
                distance: 315269,
                duration: 13500,
                evConsumption: 123,
                evChargingDuration: 456,
                driverCost: 0.8,
                vehicleCost: 10.01,
                energyCost: 30.01,
                minTotalCost: 60.03,
                maxTotalCost: 70.3,
                minTollCost: 20.01,
                maxTollCost: 30.01,
            },
            sections: [
                {
                    sectionId: 0,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T08:00:00.000Z',
                    arrivalTime: '2023-09-11T10:00:00.000Z',
                    distance: 150000,
                    duration: 7200,
                    evConsumption: 60,
                    evBatteryCapacityDeparture: 50,
                    evBatteryCapacityArrival: 40,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 40,
                            distance: 75000,
                            duration: 3600,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 38.726334, longitude: -9.14952 },
                                { latitude: 39.495162, longitude: -8.761774 },
                            ],
                        },
                        {
                            index: 1,
                            ev_consumption: 20,
                            distance: 75000,
                            duration: 3600,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 39.495162, longitude: -8.761774 },
                                { latitude: 39.904522, longitude: -8.580738 },
                            ],
                        },
                    ],
                },
                {
                    sectionId: 1,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T10:00:00.000Z',
                    arrivalTime: '2023-09-11T14:00:00.000Z',
                    distance: 165269,
                    duration: 14400,
                    evConsumption: 63,
                    evBatteryCapacityDeparture: 40,
                    evBatteryCapacityArrival: 0,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 30,
                            distance: 80000,
                            duration: 7200,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 39.904522, longitude: -8.580738 },
                                { latitude: 40.629022, longitude: -8.616218 },
                            ],
                        },
                        {
                            index: 1,
                            ev_consumption: 33,
                            distance: 85269,
                            duration: 7200,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 40.629022, longitude: -8.616218 },
                                { latitude: 41.14584, longitude: -8.610815 },
                            ],
                        },
                    ],
                },
            ],
            events: {
                timelineEvents: [
                    {
                        eventId: 1,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Departure,
                        coordinates: { latitude: 38.726334, longitude: -9.14952 },
                        address: {
                            name: 'Lisboa',
                            street: 'Praça do Comércio',
                            city: 'Lisboa',
                            countryCode: 'PRT',
                            postalCode: '1100-148',
                        },
                        expectedBatteryLevelAtDeparture: 50,
                    },
                    {
                        eventId: 2,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 0,
                    },
                    {
                        eventId: 3,
                        waypointId: 1,
                        occurredAt: '2023-09-11T10:00:00.000Z',
                        timelineEventType: TimelineEventType.IntermediateStop,
                        coordinates: { latitude: 39.904522, longitude: -8.580738 },
                        address: {
                            name: 'Leiria',
                            street: 'Rua do Comércio',
                            city: 'Leiria',
                            countryCode: 'PRT',
                            postalCode: '2400-001',
                        },
                        expectedBatteryLevelAtArrival: 40,
                        duration: 14584,
                    },
                    {
                        eventId: 4,
                        occurredAt: '2023-09-11T10:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 1,
                    },
                    {
                        eventId: 5,
                        occurredAt: '2023-09-11T14:00:00.000Z',
                        timelineEventType: TimelineEventType.Arrival,
                        coordinates: { latitude: 41.14584, longitude: -8.610815 },
                        address: {
                            name: 'Porto',
                            street: 'Rua de Santa Catarina',
                            city: 'Porto',
                            countryCode: 'PRT',
                            postalCode: '4000-447',
                        },
                        expectedBatteryLevelAtArrival: 0,
                    },
                ],
            },
        },
    ],
};

export const itineraryAutomatedMock: ItinerariesResponse = {
    itineraries: [
        {
            tourId: tourIdList[0],
            itineraryId: '517d3123-4a8f-4aa4-b07e-4b5b39b7ghi',
            status: ItineraryStatus.Current,
            summary: {
                distance: 315269,
                duration: 13500,
                evConsumption: 123,
                evChargingDuration: 456,
                driverCost: 0.8,
                vehicleCost: 10.01,
                energyCost: 30.01,
                minTotalCost: 45.03,
                maxTotalCost: 55.3,
                minTollCost: 5.01,
                maxTollCost: 10.01,
            },
            sections: [
                {
                    sectionId: 0,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T08:00:00.000Z',
                    arrivalTime: '2023-09-11T10:00:00.000Z',
                    distance: 200000,
                    duration: 7200,
                    evConsumption: 130,
                    evBatteryCapacityDeparture: 95,
                    evBatteryCapacityArrival: 21,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 130,
                            distance: 200000,
                            duration: 7200,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 38.726334, longitude: -9.14952 },
                                { latitude: 39.5467, longitude: -8.9865 },
                            ],
                        },
                    ],
                },
                {
                    sectionId: 1,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T10:00:00.000Z',
                    arrivalTime: '2023-09-11T13:00:00.000Z',
                    distance: 100000,
                    duration: 10800,
                    evConsumption: 80,
                    evBatteryCapacityDeparture: 19,
                    evBatteryCapacityArrival: 0,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 80,
                            distance: 100000,
                            duration: 10800,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 39.5467, longitude: -8.9865 },
                                { latitude: 40.3435, longitude: -8.5968 },
                            ],
                        },
                    ],
                },
                {
                    sectionId: 2,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T14:00:00.000Z',
                    arrivalTime: '2023-09-11T18:10:00.000Z',
                    distance: 15269,
                    duration: 15000,
                    evConsumption: 50,
                    evBatteryCapacityDeparture: 80,
                    evBatteryCapacityArrival: 30,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 50,
                            distance: 15269,
                            duration: 15000,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 40.3435, longitude: -8.5968 },
                                { latitude: 41.14584, longitude: -8.610815 },
                            ],
                        },
                    ],
                },
            ],
            events: {
                timelineEvents: [
                    {
                        eventId: 1,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Departure,
                        coordinates: { latitude: 38.726334, longitude: -9.14952 },
                        expectedBatteryLevelAtDeparture: 95,
                        address: {
                            city: 'Porto',
                            countryCode: 'PRT',
                            postalCode: '4000-069',
                            name: 'Praça de Almeida Garrett 49, 4000-069 Porto, Portugal',
                            street: 'Praça de Almeida Garrett',
                            number: '49',
                            region: 'Porto',
                        },
                    },
                    {
                        eventId: 2,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 0,
                    },
                    {
                        eventId: 3,
                        waypointId: 1,
                        occurredAt: '2023-09-11T10:00:00.000Z',
                        timelineEventType: TimelineEventType.IntermediateStop,
                        coordinates: { latitude: 39.5467, longitude: -8.9865 },
                        weightDelta: 300,
                        expectedBatteryLevelAtArrival: 21,
                        duration: 14584,
                        address: {
                            name: 'Coimbra',
                            street: 'Rua Example',
                            city: 'Coimbra',
                            region: 'Coimbra',
                            countryCode: 'PRT',
                            postalCode: '3000-001',
                        },
                    },
                    {
                        eventId: 4,
                        occurredAt: '2023-09-11T10:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 1,
                    },
                    {
                        eventId: 5,
                        occurredAt: '2023-09-11T13:00:00.000Z',
                        timelineEventType: TimelineEventType.ChargeStop,
                        waypointId: 12345,
                        operator: {
                            id: 'operator-1',
                            name: 'Operator Name',
                        },
                        stationId: 'e3f4393d-eeb1-494f-af31-fa868e6185ce',
                        stationName: 'Charging Station Name',
                        coordinates: { latitude: 40.3435, longitude: -8.5968 },
                        address: {
                            name: 'Aveiro',
                            street: 'Rua da Estacao',
                            city: 'Cidade',
                            region: 'Regiao',
                            countryCode: 'PRT',
                            postalCode: '1234-567',
                        },
                        expectedBatteryLevelAtArrival: 0,
                        expectedBatteryLevelAtDeparture: 80,
                        minDuration: 3600,
                        maxDuration: 7200,
                        voltage: 400,
                        current: 150,
                        power: 60,
                        supply_type: 'DC',
                        plug_type: 'CCS_COMBO_2',
                    },
                    {
                        eventId: 6,
                        occurredAt: '2023-09-11T14:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 2,
                    },
                    {
                        eventId: 7,
                        occurredAt: '2023-09-11T18:10:00.000Z',
                        timelineEventType: TimelineEventType.Arrival,
                        coordinates: { latitude: 41.14584, longitude: -8.610815 },
                        expectedBatteryLevelAtArrival: 30,
                        address: {
                            city: 'Lisboa',
                            countryCode: 'PRT',
                            postalCode: '1050',
                            name: 'Mobile Massage Lisbon by Mariah, Avenida Fontes Pereira de Melo, 1050 Lisboa, Portugal',
                            street: 'Avenida Fontes Pereira de Melo',
                            number: '',
                            region: 'Lisboa',
                        },
                    },
                ],
            },
        },
        {
            tourId: tourIdList[0],
            itineraryId: '517d3123-4a8f-4aa4-b07e-4b5b39b7def',
            status: ItineraryStatus.Current,
            summary: {
                distance: 315269,
                duration: 13500,
                evConsumption: 123,
                evChargingDuration: 456,
                driverCost: 0.8,
                vehicleCost: 10.01,
                energyCost: 30.01,
                minTotalCost: 60.03,
                maxTotalCost: 70.3,
                minTollCost: 20.01,
                maxTollCost: 30.01,
            },
            sections: [
                {
                    sectionId: 0,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T08:00:00.000Z',
                    arrivalTime: '2023-09-11T10:00:00.000Z',
                    distance: 150000,
                    duration: 7200,
                    evConsumption: 60,
                    evBatteryCapacityDeparture: 50,
                    evBatteryCapacityArrival: 40,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 40,
                            distance: 75000,
                            duration: 3600,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 38.726334, longitude: -9.14952 },
                                { latitude: 39.495162, longitude: -8.761774 },
                            ],
                        },
                        {
                            index: 1,
                            ev_consumption: 20,
                            distance: 75000,
                            duration: 3600,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 39.495162, longitude: -8.761774 },
                                { latitude: 39.8719, longitude: -8.3592 },
                            ],
                        },
                    ],
                },
                {
                    sectionId: 1,
                    type: ItinerarySectionType.Driving,
                    departureTime: '2023-09-11T10:00:00.000Z',
                    arrivalTime: '2023-09-11T16:18:55.000Z',
                    distance: 165269,
                    duration: 22735,
                    evConsumption: 63,
                    evBatteryCapacityDeparture: 80,
                    evBatteryCapacityArrival: 17,
                    spans: [
                        {
                            index: 0,
                            ev_consumption: 30,
                            distance: 80000,
                            duration: 11000,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 39.8719, longitude: -8.3592 },
                                { latitude: 40.629022, longitude: -8.616218 },
                            ],
                        },
                        {
                            index: 1,
                            ev_consumption: 33,
                            distance: 85269,
                            duration: 11735,
                            street_attributes: [StreetAttributes.RightDrivingSide],
                            truck_attributes: [TruckAttributes.Open],
                            coordinates: [
                                { latitude: 40.629022, longitude: -8.616218 },
                                { latitude: 41.14584, longitude: -8.610815 },
                            ],
                        },
                    ],
                },
            ],
            events: {
                timelineEvents: [
                    {
                        eventId: 1,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Departure,
                        coordinates: { latitude: 38.726334, longitude: -9.14952 },
                        address: {
                            name: 'Lisboa',
                            street: 'Praça do Comércio',
                            city: 'Lisboa',
                            countryCode: 'PRT',
                            postalCode: '1100-148',
                        },
                        expectedBatteryLevelAtDeparture: 50,
                    },
                    {
                        eventId: 2,
                        occurredAt: '2023-09-11T08:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 0,
                    },
                    {
                        eventId: 3,
                        waypointId: 1,
                        occurredAt: '2023-09-11T10:00:00.000Z',
                        timelineEventType: TimelineEventType.IntermediateStop,
                        coordinates: { latitude: 39.5467, longitude: -8.9865 },
                        address: {
                            name: 'Coimbra',
                            street: 'Rua Example',
                            city: 'Coimbra',
                            countryCode: 'PRT',
                            postalCode: '3000-001',
                        },
                        expectedBatteryLevelAtArrival: 40,
                        duration: 14584,
                    },
                    {
                        eventId: 4,
                        occurredAt: '2023-09-11T10:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 1,
                    },
                    {
                        eventId: 5,
                        occurredAt: '2023-09-11T13:00:00.000Z',
                        timelineEventType: TimelineEventType.ChargeStop,
                        waypointId: 54321,
                        operator: {
                            id: 'operator-2',
                            name: 'Another Operator',
                        },
                        stationId: '29adfbee-15bb-453e-a980-18f6b152aefb',
                        stationName: 'Another Charging Station',
                        coordinates: {
                            latitude: 39.8719,
                            longitude: -8.3592,
                        },
                        address: {
                            name: 'Charging Station Name',
                            street: 'Rua da Estacao',
                            city: 'Cidade',
                            countryCode: 'PRT',
                            postalCode: '1234-567',
                        },
                        expectedBatteryLevelAtArrival: 20,
                        expectedBatteryLevelAtDeparture: 80,
                        minDuration: 3600,
                        maxDuration: 7200,
                        voltage: 400,
                        current: 150,
                        power: 60,
                        supply_type: 'DC',
                        plug_type: 'CCS_COMBO_2',
                    },
                    {
                        eventId: 6,
                        occurredAt: '2023-09-11T13:00:00.000Z',
                        timelineEventType: TimelineEventType.Driving,
                        sectionId: 2,
                    },
                    {
                        eventId: 7,
                        occurredAt: '2023-09-11T16:18:55.000Z',
                        timelineEventType: TimelineEventType.Arrival,
                        coordinates: { latitude: 41.14584, longitude: -8.610815 },
                        address: {
                            name: 'Porto',
                            street: 'Rua de Santa Catarina',
                            city: 'Porto',
                            countryCode: 'PRT',
                            postalCode: '4000-447',
                        },
                        expectedBatteryLevelAtArrival: 17,
                    },
                ],
            },
        },
    ],
};

export const itineraryWithCoordsMock = itineraryMock4.itineraries?.map(it => ({
    ...it,
    drivingCoordinates: getCoordinatesFromItinerary(it),
}));
